import { Fragment, useState } from 'react'
// import { Link, NavLink, useNavigate } from "react-router-dom";
import { Popover, Transition, Menu } from '@headlessui/react'
import { PlusIcon, FunnelIcon, PencilSquareIcon, EyeIcon, TrashIcon } from '@heroicons/react/24/solid';
import { MagnifyingGlassIcon, ChevronDownIcon, EllipsisHorizontalIcon } from '@heroicons/react/24/outline'
import View from './view'
import { ORDERS } from '../../../../data/Orders';

const STATUS = [
    {
        id: 0,
        name: 'En cours',
    },
    {
        id: 1,
        name: 'Delivré',
    }
]

export default function Orders() {
    const [searchInput, setSearchInput] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);

    const handleCheckboxChange = (e) => {
        const value = e.target.value;
        setSelectedOptions((prevSelected) => {
        if (prevSelected.includes(value)) {
            return prevSelected.filter((option) => option !== value);
        } else {
            return [...prevSelected, value];
        }
        });
    };

    const filteredOrders = ORDERS.filter((item) => {
        if(selectedOptions.length !== 0) {
            if(searchInput !== '') {
                return item.name.toLowerCase().includes(searchInput.toLowerCase());
            } 
            return selectedOptions.includes(item.status);
        } else if(searchInput !== '') {
            return item.name.toLowerCase().includes(searchInput.toLowerCase());
        } 
        return true;
    });

    return(
        <>
        <div className="bg-white">
            <div className="">
                <div className="">
                    <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 p-4">
                        <div className="w-full md:w-1/2">
                            <form className="flex items-center">
                                <label for="simple-search" className="sr-only">Search</label>
                                <div className="relative w-full">
                                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                        <MagnifyingGlassIcon className="w-5 h-5 text-gray-500"/>
                                    </div>
                                    <input type='search' id="simple-search" 
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-black focus:border-black block w-full pl-10 p-2 " placeholder="Rechercher" required/>
                                </div>
                            </form>
                        </div>
                        <div className="w-full md:w-auto flex flex-col md:flex-row space-y-2 md:space-y-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0">
                            <Popover className="relative">
                            <Popover.Button className="w-full md:w-auto flex items-center justify-center py-2 px-4 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200">
                                <FunnelIcon className="h-5 w-5 mr-2 text-gray-400"/>
                                    Filtrer
                                <ChevronDownIcon className="-mr-1 ml-1.5 w-4 h-4"/>
                            </Popover.Button>

                            <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                            >
                            <Popover.Panel className="absolute right-0 z-10 text-start mt-2 w-56 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <div className="">
                                <div className="p-2">
                                    <h3 className="mb-1">
                                    <div className="flex w-full items-center justify-between bg-white text-sm text-gray-400 hover:text-gray-500">
                                        <span className="font-medium text-sm text-gray-900">Filtrer par status</span>
                                    </div>
                                    </h3>
                                    <div className="pt-3">
                                    <div className="space-y-2">
                                        {STATUS.map((status) => (
                                        <div className="flex items-center">
                                            <input
                                            id={status.id}
                                            name={status.name}
                                            defaultValue={status.id}
                                            type="checkbox"
                                            defaultChecked={selectedOptions.includes(status.id)}
                                            onChange={handleCheckboxChange}
                                            className="h-4 w-4 rounded border-gray-300 text-gray-900 focus:ring-gray-300"
                                            />
                                            <label
                                            htmlFor={status.id}
                                            className="ml-3 text-sm text-gray-600"
                                            >
                                            {status.name}
                                            </label>
                                        </div>
                                        ))}
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </Popover.Panel>
                            </Transition>
                        </Popover>
                        
                        </div>
                    </div>
                    
                    <div className="bg-white relative shadow-md sm:rounded-lg overflow-auto lg:overflow-visible">
                        <table className="w-full text-sm text-left text-gray-500">
                            <thead className="text-xs text-gray-900 uppercase bg-gray-100 ">
                                <tr>
                                  <th scope="col" className="px-4 py-4">Commande</th>
                                  <th scope="col" className="px-4 py-3">Client</th>
                                  <th scope="col" className="px-4 py-3">Prix total</th>
                                  <th scope="col" className="px-4 py-3">Statut</th>
                                    <th scope="col" className="px-4 py-3">
                                        <span className="sr-only">Actions</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                { filteredOrders.map((item) =>(
                                <tr className="border-b ">
                                    <th scope="row" className="px-4 py-3 font-medium text-gray-900 whitespace-nowrap ">{item.id}</th>
                                    <td className="px-4 py-3">{item.customer}</td>
                                    <td className="px-4 py-3">{item.total_price}$</td>
                                    <td className="px-4 py-3">{item.status}</td>
                                    <td className="px-4 py-3 flex items-center justify-end">
                                      <View order={item}/>
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    
                    {/* <nav className="flex flex-col mt-5 md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 p-4" aria-label="Table navigation">
                        <span className="text-sm font-normal text-gray-500 ">
                            Showing
                            <span className="font-semibold text-gray-900 ">1-10</span>
                            of
                            <span className="font-semibold text-gray-900 ">1000</span>
                        </span>
                        <ul className="inline-flex items-stretch -space-x-px">
                            <li>
                                <a href="#" className="flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">
                                    <span className="sr-only">Previous</span>
                                    <svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="#" className="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">1</a>
                            </li>
                            <li>
                                <a href="#" className="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">2</a>
                            </li>
                            <li>
                                <a href="#" aria-current="page" className="flex items-center justify-center text-sm z-10 py-2 px-3 leading-tight text-primary-600 bg-primary-50 border border-primary-300 hover:bg-primary-100 hover:text-primary-700 ">3</a>
                            </li>
                            <li>
                                <a href="#" className="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">...</a>
                            </li>
                            <li>
                                <a href="#" className="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">100</a>
                            </li>
                            <li>
                                <a href="#" className="flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">
                                    <span className="sr-only">Next</span>
                                    <svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </nav> */}
                </div>
            </div>
        </div>
        
      </>
    )
    }